// extracted by mini-css-extract-plugin
export default {"stickyBottomCover":"styles_stickyBottomCover__ju80U"};